const initialState = {
  dataParentescos: [],
};

export function parentesco(state = initialState, action) {
  switch (action.type) {
    case "DATA_PARENTESCO":
      return { ...state, dataParentescos: action.parentesco };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/parentesco/reducer.js